import { FloorPlanStatusEnum } from '@api/enum';
import { IFloorPlanModel } from '@api/models';
import { createFloorPlan } from '@api/services/site-walk.service';
import { useMutation } from '@tanstack/react-query';

import { useMemo } from 'react';
import * as Yup from 'yup';

/* -------------------------------------------------------------------------------------------------
 * Hook: useRFIsProcoreShareForm
 * -----------------------------------------------------------------------------------------------*/

interface IAddfloorPlanOptions {
    clientId: string;
    projectId: string;
}

const useAddFloorPlanForm = (options: IAddfloorPlanOptions) => {
    const { clientId, projectId } = options;

    const schema = useMemo(() => {
        return Yup.object({
            name: Yup.string().required('This field is required'),
            // folder: Yup.string().required('This field is required'),
            status: Yup.string().required('This field is required'),
            // timezone: Yup.string().required('This field is required'),
            file: Yup.string().required('This field is required'),
        });
    }, []);

    const initialValues: Pick<
        IFloorPlanModel,
        'name' | 'file' | 'folder' | 'location' | 'status' | 'timezone' | 'storage'
    > = useMemo(() => {
        return {
            name: '',
            folder: '',
            location: {
                latitude: '',
                longitude: '',
            },
            timezone: '',
            storage: '',
            status: FloorPlanStatusEnum.ENABLED,
            file: null as File,
        };
    }, []);

    const addFloorPlanMutation = useMutation((payload: FormData) => createFloorPlan(clientId, projectId, payload));

    const submit = async (
        values: Pick<IFloorPlanModel, 'name' | 'file' | 'folder' | 'location' | 'status' | 'timezone' | 'storage'>
    ) => {
        const formData = new FormData();

        formData.append('name', values.name);
        formData.append('folder', values.folder);
        formData.append('status', values.status);
        formData.append('timezone', values.timezone);
        formData.append('storage', values.storage);
        formData.append('location[latitude]', values.location.latitude);
        formData.append('location[longitude]', values.location.longitude);
        formData.append('file', values.file);

        try {
            await addFloorPlanMutation.mutateAsync(formData);
        } catch (err: any) {
            throw new Error(err);
        }
    };

    return {
        initialValues,
        schema,
        isSubmitting: addFloorPlanMutation.isLoading,
        submit,
    };
};

export default useAddFloorPlanForm;
